// Phase G3 Stage 2: /pal — kid-side cosmetic pal swap (NO parent gate).
import { createFileRoute } from "@tanstack/react-router";
import { MascotPicker } from "@/screens/MascotPicker";

export const Route = createFileRoute("/pal")({
  component: MascotPicker,
});
